





















import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import {GetPatBedschedus} from "@/api/hd"

@Component({
	components: {}
})
export default class PatientInfo extends AbpBase {
	@Prop() patient: any
	query: any = {
		dates: [],
		date: '最近一个月'
	}
	total = 0
	pageSize = 10
	page = 1

	created() {
		this.setDate(30)
	}
	pageChange(val:any){
		this.page = val
		this.init()
	}
	pageSizeChange(val:any){
		this.pageSize = val
		this.init()
	}
	dateChange(val: string) {
		switch (val) {
			case '全部':
				this.query.dates = []
				this.init()
				break
			case '最近一周':
				this.setDate(7)
				break
			case '最近一个月':
				this.setDate(30)
				break
			case '最近半年':
				this.setDate(182)
				break
			case '最近一年':
				this.setDate(365)
				break
			case '最近三年':
				this.setDate(365 * 3)
				break
		}
	}

	setDate(days: number) {
		const end = new Date()
		let start = new Date()
		start.setTime(start.getTime() - 3600 * 1000 * (days - 1) * 24);
		this.query.dates = [start, end]
		this.init()
	}

	loading = false
	columns = [
		{
			title: '日期',
			key: 'inputDate',
			width:180,
			render:(h: any, params: any)=>{
				return h('span', this.formatDate(params.row.date))
			}
		},  {
			title: '床位编号',
			key: 'bedCode'
		}, {
			title: '透析班次',
			key: 'shiftName'
		},{
			title: '透析模式',
			key: 'dialysisWay'
		},{
			title: '透析区域',
			key: 'wardName'
		},
	]
	data = []

	async init() {
		let query: any = {
			PatientId: this.patient.id,
			SkipCount:this.page,
			MaxResultCount:this.pageSize
		}
		if (this.query.dates[0]) {
			query['StartDate'] = this.formatDate(this.query.dates[0])
			query['EndDate'] = this.formatDate(this.query.dates[1])
		}
		let res = await GetPatBedschedus(query)
		this.data = res.objects.items
		this.total = res.objects.totalCount
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/bedRecord/index.vue